export class Evaluacion {
    idEvaluacion !: number;
    tipoJardin !: number;
    nombre !: string;
    preguntas !: Pregunta[]
}

export class Pregunta {
    idPregunta !: number;
    orden !: number;
    dimension !: number;
    pregunta !: string;
    indicador !: string;
    alternativas !: Alternativa[];
    alternativaSeleccionada !: number;
    alternativaCorrecta !: number;
    justificacion !: string;
    letraAlternativaCorrecta !: string;
}

export class  Alternativa {
    idAlternativa !: number;
    orden !: number;
    alternativa !: string;
}